module.exports = __webpack_public_path__ + "static/Bg11-a06866f0e18fb8e0957767b00c3a29d9.png";